/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Meta_TitleInputs */

const es_l7_meta_title = /** @type {(inputs: L7_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquilar tu barco de Lista Séptima | Zarpar`)
};

const gl_l7_meta_title = /** @type {(inputs: L7_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alugar o teu barco de Lista Sétima | Zarpar`)
};

const en_l7_meta_title = /** @type {(inputs: L7_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent out your List 7 boat | Zarpar`)
};

/**
* | output |
* | --- |
* | "Rent out your List 7 boat \| Zarpar" |
*
* @param {L7_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_meta_title = /** @type {((inputs?: L7_Meta_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Meta_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_meta_title(inputs)
	if (locale === "en") return en_l7_meta_title(inputs)
	return es_l7_meta_title(inputs)
});